import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject } from "rxjs";
import { TokenService } from "./token.service";
import { EncryptService } from "./encrypt.service";
import { ToastrService } from "ngx-toastr";
import { StorageService, SESSION_STORAGE } from 'ngx-webstorage-service';


@Injectable({
    providedIn: 'root'
    
})

export class CommonService {

    toastr: ToastrService;

    constructor(@Inject(SESSION_STORAGE) private storage:StorageService){

    }
    //Get the roles of the current logged in user and check if it is admin
    async checkLoggedUserIsAdmin(currentUserId?: any) {
        return true;
    }
}